export class VehicleModel {
    public vehicleId: string;
    public orgaisationId: string;
    public vehicleTypeCode: string;
    public vehicleCode: string;
    public vehicleName: string;
    public vehicleIdentification: string;
    public statusCode: string;
}